// src/services/game.js
class GameService {
    constructor() {
        // Adjust extensions to what you actually use: js/ts/json
        const modules = import.meta.glob('./games/*.{js,ts,json}', { eager: true })

        this.games = Object.entries(modules)
            .map(([path, mod]) => {
                const conf = mod?.default ?? mod // grab the default export (or whole module as fallback)
                var filename = path.split('/').pop()
                filename = filename.split('_').pop()
                const key = filename.replace(/\.(js|ts|json)$/, '')
                return { key, ...conf }
            })
            // Ignore non-game modules in this folder (e.g. types.ts, shared helpers).
            .filter((game) => game.content)

        // Optional: sanity check in dev
        if (import.meta.env.DEV) {
            console.log(
                '[GameService] loaded games:',
                this.games.map((g) => g.key),
            )
        }
    }

    list(desiredCategory = null) {
        return this.games.filter((g) => {
            return g.category === desiredCategory || desiredCategory === null
        })
    }

    getClassics() {
        return this.list('classic')
    }

    getMinigames() {
        return this.list('minigames')
    }

    get(key) {
        return this.games.find((g) => g.key === key)
    }

    startGame() {}
}

export default new GameService()
